import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Single navigation link primitive with active-route styling.
export const NavLink = ({ to, label, Icon, testid, onClick }) => {
  const location = useLocation();
  const active = location.pathname === to;
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`flex items-center gap-2 text-sm font-medium transition-colors ${active ? 'text-[#48CAE4]' : 'text-muted-foreground hover:text-white'}`}
      data-testid={testid}
    >
      {Icon && <Icon className="w-4 h-4" />} {label}
    </Link>
  );
};
